var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.281,
    height: 18.281,
    viewBox: "0 0 18.281 18.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin",
    d: "M16.962,0H1.318A1.318,1.318,0,0,0,0,1.318V16.962a1.318,1.318,0,0,0,1.318,1.318H16.962a1.318,1.318,0,0,0,1.318-1.318V1.318A1.318,1.318,0,0,0,16.962,0ZM6.484,13.818H4.258V7.12H6.484ZM5.371,6.206H5.357a1.16,1.16,0,1,1,.029-2.314,1.161,1.161,0,1,1-.015,2.314Zm9.14,7.612H12.285V10.235c0-.9-.322-1.514-1.128-1.514a1.219,1.219,0,0,0-1.142.814,1.524,1.524,0,0,0-.073.543v3.74H7.716s.029-6.069,0-6.7H9.942v.948a2.21,2.21,0,0,1,2.006-1.105c1.465,0,2.563.957,2.563,3.014Zm0,0",
    fill: "#5861ae",
    opacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.55fd7b1f6de044d39c5b824137c88d80.svg";
export { ForwardRef as ReactComponent };